import { render, staticRenderFns } from "./editBoard.vue?vue&type=template&id=76bce668&"
import script from "./editBoard.vue?vue&type=script&lang=js&"
export * from "./editBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports